import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CButtonGroup,
  CCol,
  CFormCheck,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CRow,
} from '@coreui/react'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import AttachLink from '../attachLink'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail, validateLink } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'
import TemplateAccordion from '../templateAccordion'

const FitnessPlansModal = ({ componentData, modifyData, modalSpecificData, onCancel }) => {
  const { isEdit, type, cardIndex } = modalSpecificData

  const { userSessionObj } = useContext(GlobalContext)
  const [isMultiple, setIsMultiple] = useState(false)
  const [title, setTitle] = useState('')
  const [singleCardData, setSingleCardData] = useState({
    image_s3key: '',
    heading: '',
    description: ``,
    link: {
      type: '',
      data: {},
    },
  })
  const [cardAData, setCardAData] = useState({
    image_s3key: '',
    heading: '',
    description: ``,
    link: {
      type: '',
      data: {},
    },
  })
  const [cardBData, setCardBData] = useState({
    image_s3key: '',
    heading: '',
    description: ``,
    link: {
      type: '',
      data: {},
    },
  })
  const [errorData, setErrorData] = useState({})
  const [singleImageData, setSingleImageData] = useState([])
  const [cardAImageData, setCardAImageData] = useState([])
  const [cardBImageData, setCardBImageData] = useState([])
  const { loader, setLoader } = useContext(AppContext)

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    const singleImgData = [
      {
        title: '',
        id: 'singleImgData',
        width: 804,
        height: 596,
        divheight: '9.6rem',
        divwidth: '13rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          //   clearError('imageS3key')
          setSingleCardData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setSingleCardData((prev) => ({ ...prev, image_s3key: '' }))
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '6px',
        imagePaddingY: '6px',
        imgUploaderBg: '#f5f5f5',
      },
    ]
    const cardAImgData = [
      {
        title: '',
        id: 'cardAImgData',
        width: 804,
        height: 278,
        divheight: '4.5rem',
        divwidth: '13rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          //   clearError('imageS3key')
          setCardAData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardAData((prev) => ({ ...prev, image_s3key: '' }))
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '6px',
        imagePaddingY: '6px',
        imgUploaderBg: '#f5f5f5',
        imgUploaderDivFlex: 'flex-row justify-content-center align-items-around',
        btnMarginTop: '2px',
      },
    ]
    const cardBImgData = [
      {
        title: '',
        id: 'cardBImgData',
        width: 804,
        height: 278,
        divheight: '4.5rem',
        divwidth: '13rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          //   clearError('imageS3key')
          setCardBData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardBData((prev) => ({ ...prev, image_s3key: '' }))
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '6px',
        imagePaddingY: '6px',
        imgUploaderBg: '#f5f5f5',
        imgUploaderDivFlex: 'flex-row justify-content-center align-items-around',
        btnMarginTop: '2px',
      },
    ]
    if (isEdit) {
      if (type === 'HEADING') {
        setTitle(componentData?.data?.title)
        return
      }
      setIsMultiple(modalSpecificData?.modalData?.is_multiple)
      console.log('modalSpecificData?.modalData', modalSpecificData?.modalData)
      if (modalSpecificData?.modalData?.is_multiple) {
        setCardAData(modalSpecificData?.modalData?.card_a)
        setCardBData(modalSpecificData?.modalData?.card_b)

        cardAImgData[0]['assetId'] = modalSpecificData?.modalData?.card_a?.image_s3key
        cardAImgData[0]['imageUrl'] = getThumbnail(
          userSessionObj.session_data.cf_domain_name,
          modalSpecificData?.modalData?.card_a?.image_s3key,
        )

        cardBImgData[0]['assetId'] = modalSpecificData?.modalData?.card_b?.image_s3key
        cardBImgData[0]['imageUrl'] = getThumbnail(
          userSessionObj.session_data.cf_domain_name,
          modalSpecificData?.modalData?.card_b?.image_s3key,
        )
      }

      if (!modalSpecificData?.modalData?.is_multiple) {
        setSingleCardData({
          image_s3key: modalSpecificData?.modalData?.image_s3key,
          heading: modalSpecificData?.modalData?.heading,
          description: modalSpecificData?.modalData?.description,
          link: modalSpecificData?.modalData?.link,
        })

        singleImgData[0]['assetId'] = modalSpecificData?.modalData?.image_s3key
        singleImgData[0]['imageUrl'] = getThumbnail(
          userSessionObj.session_data.cf_domain_name,
          modalSpecificData?.modalData?.image_s3key,
        )
      }
    }

    setSingleImageData(singleImgData)
    setCardAImageData(cardAImgData)
    setCardBImageData(cardBImgData)
  }, [])

  const onCardTypeChange = (event) => {
    const { value } = event.target

    setSingleCardData((prev) => ({ ...prev, image_s3key: '' }))
    setCardAData((prev) => ({ ...prev, image_s3key: '' }))
    setCardBData((prev) => ({ ...prev, image_s3key: '' }))

    const singleImgData = [
      {
        title: '',
        id: 'singleImgData',
        width: 804,
        height: 596,
        divheight: '9.6rem',
        divwidth: '13rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('singleCardDataImg')
          setSingleCardData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setSingleCardData((prev) => ({ ...prev, image_s3key: '' }))
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '6px',
        imagePaddingY: '6px',
        imgUploaderBg: '#f5f5f5',
      },
    ]
    const cardAImgData = [
      {
        title: '',
        id: 'cardAImgData',
        width: 804,
        height: 278,
        divheight: '4.5rem',
        divwidth: '13rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('cardBDataImg')
          setCardAData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardAData((prev) => ({ ...prev, image_s3key: '' }))
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '6px',
        imagePaddingY: '6px',
        imgUploaderBg: '#f5f5f5',
        imgUploaderDivFlex: 'flex-row justify-content-center align-items-around',
        btnMarginTop: '2px',
      },
    ]
    const cardBImgData = [
      {
        title: '',
        id: 'cardBImgData',
        width: 804,
        height: 278,
        divheight: '4.5rem',
        divwidth: '13rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('cardBDataImg')
          setCardBData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardBData((prev) => ({ ...prev, image_s3key: '' }))
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '6px',
        imagePaddingY: '6px',
        imgUploaderBg: '#f5f5f5',
        imgUploaderDivFlex: 'flex-row justify-content-center align-items-around',
        btnMarginTop: '2px',
      },
    ]

    setSingleImageData(singleImgData)
    setCardAImageData(cardAImgData)
    setCardBImageData(cardBImgData)

    value === 'single' ? setIsMultiple(false) : setIsMultiple(true)
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (title.trim().length === 0 && type === 'HEADING') {
      isFormValid = false
      temp.title = 'Heading cannot be Empty!'
    }

    if (
      type === 'CARD' &&
      isMultiple &&
      cardAData.image_s3key.trim().length === 0 &&
      cardBData.image_s3key.trim().length === 0
    ) {
      isFormValid = false
      temp.cardBDataImg = 'Upload Image!'
    }
    if (type === 'CARD' && !isMultiple && singleCardData.image_s3key.trim().length === 0) {
      isFormValid = false
      temp.singleCardDataImg = 'Upload Image!'
    }

    if (
      type === 'CARD' &&
      isMultiple &&
      cardAData.link.type &&
      !validateLink(cardAData.link).isValid
    ) {
      isFormValid = false
      temp.cardALink = validateLink(cardAData.link).error
    }
    if (
      type === 'CARD' &&
      isMultiple &&
      cardBData.link.type &&
      !validateLink(cardBData.link).isValid
    ) {
      isFormValid = false
      temp.cardBLink = validateLink(cardBData.link).error
    }
    if (
      type === 'CARD' &&
      !isMultiple &&
      singleCardData.link.type &&
      !validateLink(singleCardData.link).isValid
    ) {
      isFormValid = false
      temp.singleCardLink = validateLink(singleCardData.link).error
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  const handleSave = () => {
    if (!validateInfo()) return
    let tempdata = componentData.data
    if (type === 'CARD') {
      let elementObj = isMultiple
        ? {
            is_multiple: isMultiple,
            card_a: cardAData,
            card_b: cardBData,
          }
        : {
            ...singleCardData,
            is_multiple: isMultiple,
          }

      if (!isEdit) {
        tempdata?.card_data.splice(cardIndex + 1, 0, elementObj)
      } else {
        tempdata?.card_data.splice(cardIndex, 1, elementObj)
      }

      modifyData(componentData.id, tempdata)
      return
    }

    tempdata['title'] = title

    modifyData(componentData.id, tempdata)
  }

  let multiAccordionItems = [
    {
      title: 'Add text to Image-A',
      description: 'Specify elements under the card which contain Image-A.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Heading (A)</h6>
            <CustomDescriptionBox
              limit={38}
              rows={1}
              value={cardAData.heading}
              onChange={(value) => setCardAData((prev) => ({ ...prev, heading: value }))}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
              useFormInput={true}
            />
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Paragraph</h6>
            <CustomDescriptionBox
              limit={300}
              rows={3}
              value={cardAData.description}
              onChange={(value) => setCardAData((prev) => ({ ...prev, description: value }))}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1">
            <AttachLink
              linkData={cardAData.link}
              id={'cardAData'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                clearError('cardALink')
                setCardAData((prev) => ({ ...prev, link: value }))
              }}
              astrick={true}
            />
            <div className="message-text error-message">
              <p>{errorData.cardALink}</p>
            </div>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'Add text to Image-B',
      description: 'Specify elements under the card which contain Image-B.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Heading (B)</h6>
            <CustomDescriptionBox
              limit={38}
              rows={1}
              value={cardBData.heading}
              onChange={(value) => setCardBData((prev) => ({ ...prev, heading: value }))}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
              useFormInput={true}
            />
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Paragraph (B)</h6>
            <CustomDescriptionBox
              limit={300}
              rows={3}
              value={cardBData.description}
              onChange={(value) => setCardBData((prev) => ({ ...prev, description: value }))}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1">
            <AttachLink
              linkData={cardBData.link}
              id={'cardBData'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                clearError('cardBLink')
                setCardBData((prev) => ({ ...prev, link: value }))
              }}
              astrick={true}
            />
            <div className="message-text error-message">
              <p>{errorData.cardBLink}</p>
            </div>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
  ]
  let singleAccordionItems = [
    {
      title: 'Add text',
      description: 'Specify elements under the card.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Heading</h6>
            <CustomDescriptionBox
              limit={38}
              rows={1}
              value={singleCardData.heading}
              onChange={(value) => setSingleCardData((prev) => ({ ...prev, heading: value }))}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
              useFormInput={true}
            />
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Paragraph</h6>
            <CustomDescriptionBox
              limit={300}
              rows={3}
              value={singleCardData.description}
              onChange={(value) => setSingleCardData((prev) => ({ ...prev, description: value }))}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1">
            <AttachLink
              linkData={singleCardData.link}
              id={'singleCardData'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                clearError('singleCardLink')
                setSingleCardData((prev) => ({ ...prev, link: value }))
              }}
              astrick={true}
            />
            <div className="message-text error-message">
              <p>{errorData.singleCardLink}</p>
            </div>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
  ]

  return (
    <CModal size="lg" className="" visible={true}>
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      <CModalHeader style={{ borderBottom: 0 }} className="d-flex justify-content-center">
        <p>
          <b style={{ fontWeight: '500', fontSize: '1.3rem' }}>Add New card to Slider</b>
        </p>
      </CModalHeader>
      {type === 'CARD' ? (
        <CModalBody style={{ height: '72vh' }} className="px-5 static-scrollbar-class">
          <CRow className="">
            <CCol>
              <h6 className="font-13px">
                Select the carousel Image style <span style={{ color: 'red' }}>*</span>
              </h6>
              <CButtonGroup
                id="group1"
                role="group"
                aria-label="Basic checkbox toggle button group"
                style={{ fontSize: '12px' }}
                className="w-100"
              >
                <div className="mt-2 d-flex justify-content-between w-100">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <CFormCheck
                      type="radio"
                      id="single"
                      label="Single Image ( 804px X 596px )"
                      value="single"
                      checked={!isMultiple}
                      onChange={(e) => onCardTypeChange(e)}
                    />
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ width: '15.525rem', height: '13.53rem', background: '#dbdbdb' }}
                    >
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          width: '14.2rem',
                          height: '10.84rem',
                          background: '#fff',
                          border: !isMultiple ? '1px solid #2172eb' : '',
                        }}
                      >
                        {singleImageData && (
                          <ImageUploader data={singleImageData} isDisabled={isMultiple} />
                        )}
                      </div>
                    </div>
                    <div className="message-text error-message">
                      <p>{errorData.singleCardDataImg}</p>
                    </div>
                  </div>
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <div
                      style={{ paddingLeft: '18%' }}
                      className="w-100 d-flex justify-content-center"
                    >
                      <CFormCheck
                        type="radio"
                        id="double"
                        label="Double Image ( 804px X 278px each )"
                        value="multi"
                        checked={isMultiple}
                        onChange={(e) => onCardTypeChange(e)}
                      />
                    </div>
                    <div className="d-flex">
                      <div className="px-2">
                        <div className=" h-50 d-flex justify-content-center align-items-center">
                          <p className="mt-3" style={{ fontSize: '13px', color: '#787878' }}>
                            Image - A
                          </p>
                        </div>
                        <div className=" h-50 d-flex justify-content-center align-items-center">
                          <p className="mt-3" style={{ fontSize: '13px', color: '#787878' }}>
                            Image - B
                          </p>
                        </div>
                      </div>
                      <div
                        className="d-flex flex-column justify-content-between align-items-center py-2"
                        style={{ width: '15.525rem', height: '13.53rem', background: '#dbdbdb' }}
                      >
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{
                            width: '14.2rem',
                            height: '5.879rem',
                            background: '#fff',
                            border: isMultiple ? '1px solid #2172eb' : '',
                          }}
                        >
                          {cardAImageData && (
                            <ImageUploader data={cardAImageData} isDisabled={!isMultiple} />
                          )}
                        </div>
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{
                            width: '14.2rem',
                            height: '5.879rem',
                            background: '#fff',
                            border: isMultiple ? '1px solid #2172eb' : '',
                          }}
                        >
                          {cardBImageData && (
                            <ImageUploader data={cardBImageData} isDisabled={!isMultiple} />
                          )}
                        </div>
                      </div>
                    </div>
                    <div style={{ paddingLeft: '18%' }} className="message-text error-message">
                      <p>{errorData.cardBDataImg}</p>
                    </div>
                  </div>
                </div>
              </CButtonGroup>
            </CCol>
          </CRow>
          <CRow>
            <TemplateAccordion
              items={isMultiple ? multiAccordionItems : singleAccordionItems}
              styles={''}
            />
          </CRow>
        </CModalBody>
      ) : (
        <CModalBody className="px-5">
          <div style={{ fontSize: '1.3rem' }} className="d-flex justify-content-center">
            <p>
              <b style={{ fontWeight: '500' }}>Text Editor</b>
            </p>
          </div>
          <CRow className="my-3 mt-5">
            <CCol>
              <h6 className="font-13px">
                Heading1 <span style={{ color: 'red' }}>*</span>
              </h6>
              <CustomDescriptionBox
                limit={45}
                rows={1}
                value={title}
                onChange={setTitle}
                style={{ fontSize: '13px' }}
                isMandatory={true}
                errorText={errorData.title}
              />
            </CCol>
          </CRow>
          {/* <div className="mt-4 d-flex justify-content-end">
            <CButton
              style={{ color: 'black', border: '1px solid black' }}
              className="mx-4 bg-white rounded-1 btn-focus-none"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton className=" bg-black rounded-1 btn-focus-none" onClick={handleSave}>
              Save
            </CButton>
          </div> */}
        </CModalBody>
      )}

      <CModalFooter style={{ borderTop: 0 }} className="px-5">
        {/* <div className="mt-4 d-flex justify-content-end"> */}
        <CButton
          style={{ color: 'black', border: '1px solid black' }}
          className="mx-4 bg-white rounded-1 btn-focus-none"
          onClick={onCancel}
        >
          Cancel
        </CButton>
        <CButton className=" bg-black rounded-1 btn-focus-none" onClick={handleSave}>
          Save
        </CButton>
        {/* </div> */}
      </CModalFooter>
    </CModal>
  )
}

export default FitnessPlansModal
